export default __webpack_public_path__ + "static/media/somerset-house-no-processing.3ed177a8.jpg";